import useManufacturers from "@/hooks/useManufacturers";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Factory } from "lucide-react";

/**
 * Compact manufacturer filter dropdown for list pages (Pipeline, Deals,
 * Leads). Returns "__all" for the unfiltered state — callers map this to
 * empty string before passing to the API.
 */
export default function ManufacturerFilter({ value, onChange, testId = "supplier-filter", placeholder = "All suppliers", className = "h-10 w-44 sm:w-52 rounded-2xl" }) {
  const mfrs = useManufacturers();
  return (
    <Select value={value || "__all"} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
      <SelectTrigger className={className} data-testid={testId}>
        <Factory className="h-3.5 w-3.5 mr-1.5 text-muted-foreground shrink-0" />
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent className="rounded-2xl">
        <SelectItem value="__all">{placeholder}</SelectItem>
        {mfrs.map((m) => (
          <SelectItem key={m.id} value={m.id} data-testid={`supplier-option-${m.id}`}>{m.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
